import { mainApi } from "../services/main/api";

const extendedApi = mainApi.injectEndpoints({
    endpoints: builder => ({
        deleteArtifactById: builder.mutation<DeleteArtifactByIdResponse, DeleteArtifactByIdRequest>(
            {
                query: (request?: DeleteArtifactByIdRequest) => ({
                    url: "deleteArtifactById",
                    body: request,
                    method: "POST",
                }),
            }
        ),
    }),
    overrideExisting: false,
});

export const { useDeleteArtifactByIdMutation } = extendedApi;

export interface DeleteArtifactByIdRequest {
    artifactType: string;
    artifactId: string;
    businessUseCase: string;
    clientName: string;
}

export interface DeleteArtifactByIdResponse {
    status: string;
}
